/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { image } from "lib/sanity/sanity";
import { SanityFigure } from "lib/sanity/types";

type FigureFormat = "jpg" | "png";

export const Figure: React.FC<{
  item: SanityFigure;
  width: number;
  format: FigureFormat;
}> = (props) => {
  const src1x = createImageURL(props.item, props.width, props.format);
  const src2x = createImageURL(props.item, props.width * 2, props.format);
  const src3x = createImageURL(props.item, props.width * 3, props.format);
  const srcSet = [src1x, src2x + " 2x", src3x + " 3x"].join(", ");

  if (!src1x) {
    return null;
  }

  return (
    <img srcSet={srcSet} src={src1x} alt={props.item.alt} loading="lazy" />
  );
};

const createImageURL = (
  item: SanityFigure,
  width: number,
  format: FigureFormat
) => {
  return image(item.image).width(width).format(format).url();
};
